import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import * as amplitude from '@amplitude/analytics-browser';
import Headroom from 'headroom.js';
import GifLoader from './components/GifLoader';
import Slideshow from './components/Slideshow';

function idGo(id) {
    $('html, body').animate({
        scrollTop: ($("#"+id).offset().top-130)
    }, 500);
}
document.getElementById('menu-about').onclick = ()=>idGo('about');
document.getElementById('menu-components').onclick = ()=>idGo('components');
document.getElementById('menu-gameplay').onclick = ()=>idGo('gameplay');
document.getElementById('menu-previews').onclick = ()=>idGo('previews');
document.getElementById('preorder-now').onclick = ()=>$('#preorder-popup-container').css('display', 'flex');
document.getElementById('dragon-button').onclick = ()=>$('#preorder-popup-container').css('display', 'flex');
document.getElementById('header-button').onclick = ()=>$('#preorder-popup-container').css('display', 'flex');
document.getElementById('preorder-popup-x').onclick = ()=>$('#preorder-popup-container').css('display', 'none');


ReactDOM.render(
    <GifLoader src="/images/gifs/Character.gif" alt="combine a class sheet and species sheet to create your character" />,
    document.getElementById('gif-1')
);

ReactDOM.render(
    <GifLoader src="/images/gifs/Dice_Upgrade.gif" alt="dice upgrade" />,
    document.getElementById('gif-1b')
);

ReactDOM.render(
    <GifLoader src="/images/gifs/Freelancers_Bag.gif" alt="travel bag" />,
    document.getElementById('gif-2')
);

ReactDOM.render(
    <GifLoader src="/images/gifs/Freelancers_Map.gif" alt="quest map" />,
    document.getElementById('gif-3')
);

ReactDOM.render(
    <GifLoader src="/images/gifs/App_Spin.gif" alt="Freelancers app" />,
    document.getElementById('gif-4')
);

ReactDOM.render(
    <Slideshow
        mapSlides={[]}
        id='photo-slideshow'
        container="photo-slideshow"
        slides={[
            <img className="slide-photo" src="/images/pictures/Freelancers -003.jpg" alt="Box" />,
            <img className="slide-photo" src="/images/pictures/Freelancers -004.jpg" alt="Blaze" />,
            <img className="slide-photo" src="/images/pictures/Freelancers -009.jpg" alt="" />,
            <img className="slide-photo" src="/images/pictures/Freelancers -011.jpg" alt="" />,
            <img className="slide-photo" src="/images/pictures/Freelancers -012.jpg" alt="" />,
            <img className="slide-photo" src="/images/pictures/Freelancers -013.jpg" alt="" />,
            <img className="slide-photo" src="/images/pictures/Freelancers -014.jpg" alt="" />,
            <img className="slide-photo" src="/images/pictures/Freelancers -015.jpg" alt="" />,
            <img className="slide-photo" src="/images/pictures/Freelancers -017.jpg" alt="" />,
            <img className="slide-photo" src="/images/pictures/Freelancers -018.jpg" alt="" />,
            <img className="slide-photo" src="/images/pictures/Freelancers -019-edited.jpg" alt="" />,
            <img className="slide-photo" src="/images/pictures/Freelancers -020.jpg" alt="" />,
            <img className="slide-photo" src="/images/pictures/Freelancers -021.jpg" alt="" />,
            <img className="slide-photo" src="/images/pictures/Freelancers -025.jpg" alt="" />,
        ]}
    />
    , document.getElementById('photo-slideshow')
);

let headroom  = new Headroom(
    document.querySelector("#top-ribbon"),
    {
        offset: 130,
    }
);
headroom.init();



amplitude.init('e78d272be22656c1b003bb39daefff1a', undefined, { defaultTracking: { sessions: true, pageViews: true, formInteractions: true, fileDownloads: true }});
